import { Box, Stack, Typography } from '@mui/material';
import { useAxisTooltip, useLegend } from '@mui/x-charts';

export const QueueChartLegend = () => {
  const legend = useLegend();
  const tooltip = useAxisTooltip();

  const visibleSeriesIds = new Set(
    tooltip?.seriesItems.filter(s => s.value).map(s => s.seriesId) ?? []
  );

  return (
    <Stack
      direction='row'
      flexWrap='wrap'
      gap={1.5}
      justifyContent='center'
      sx={{ p: 1 }}>
      {legend.items.map(item => {
        const isFilteredOut =
          tooltip !== null &&
          item.seriesId !== undefined &&
          !visibleSeriesIds.has(item.seriesId);

        return (
          <Stack
            alignItems='center'
            direction='row'
            gap={0.5}
            key={item.id}
            sx={{ visibility: isFilteredOut ? 'hidden' : 'visible' }}>
            <Box
              sx={{
                bgcolor: item.color,
                borderRadius: '2px',
                height: 12,
                width: 12
              }}
            />
            <Typography variant='caption'>{item.label}</Typography>
          </Stack>
        );
      })}
    </Stack>
  );
};
